import { render, staticRenderFns } from "./KeyDetails.vue?vue&type=template&id=0a5a5bae&scoped=true&"
import script from "./KeyDetails.vue?vue&type=script&lang=ts&"
export * from "./KeyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./KeyDetails.vue?vue&type=style&index=0&id=0a5a5bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a5bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
